import mocker from 'mocker-data-generator';
import {
  StringGroup,
  AuthorizedStringGroupsDocument,
} from 'src/generated/graphql';
import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';

const stringGroup: StringGroup = {
  __typename: 'StringGroup',
  sourceReviewRequestedTimestamp: '1641034800000',
  sourceReviewRequester: 'TestUser',
  stringGroupName: 'TestStringGroup',
};

const fakedStringGroup = {
  __typename: {
    static: 'StringGroup',
  },
  sourceReviewRequestedTimestamp: {
    faker: 'date.recent',
  },
  sourceReviewRequester: {
    faker: 'internet.userName',
  },
  stringGroupName: {
    faker: 'lorem.words',
  },
};

const stringGroups = {
  __typename: {
    static: 'StringGroups',
  },
  stringGroups: {
    hasMany: 'fakedStringGroup',
    amount: 5,
    unique: true,
  },
};

export const authorizedStringGroupsMock = (async () => {
  const { fakedStringGroups } = await mocker()
    .seed('fakedStringGroup', [stringGroup])
    .schema('fakedStringGroup', fakedStringGroup, 4)
    .schema('fakedStringGroups', stringGroups, 1)
    .build();

  return {
    request: {
      query: AuthorizedStringGroupsDocument,
      variables: MATCH_ANY_PARAMETERS,
    },
    result: {
      data: {
        authorizedStringGroups: fakedStringGroups[0],
      },
    },
  };
})();
